module.exports = __webpack_public_path__ + "img/saishianpai-icon-1.3082349a.png";